import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { DisabledReq } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface searchXhsLikesParams extends ActiomCommonParams {
    num: number;
    cursor: string | null;
}

export interface LikesResponse {
    code: number;
    success: boolean;
    msg: string;
    data: LikesDetail;
}

export interface LikesDetail {
    message_list: {
        time: number;
        user_info: {
            fstatus: string;
            red_official_verify_type: number;
            xsec_token: string;
            userid: string;
            nickname: string;
            image: string;
        };
        item_info: {
            image: string;
            status: number;
            id: string;
            content: string;
            image_info: {
                url: string;
                width: number;
                height: number;
            };
            illegal_info: {
                illegal_status: string;
                status: number;
                desc: string;
            };
            link: string;
            user_info: {
                userid: string;
                nickname: string;
                image: string;
                red_official_verify_type: number;
            };
            xsec_token: string;
            type: string;
        };
        comment_info: {
            illegal_info: {
                status: number;
                desc: string;
                illegal_status: string;
            };
            status: number;
            liked: boolean;
            like_count: number;
            id: string;
            content: string;
        };
        liked: boolean;
        time_flag: number;
        type: string;
        title: string;
        score: number;
        track_type: string;
        id: string;
    }[];
    has_more: boolean;
    strCursor: string;
}

export type PublishAction = CommonAction<searchXhsLikesParams, LikesDetail | Record<string, unknown>>;

export const searchXhsWebLikes: PublishAction = async (_task, params) => {
    if (DisabledReq) return response(0, "获取点赞收藏成功", { message_list: [], has_more: false, strCursor: "" });
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://www.xiaohongshu.com/",
        origin: "https://www.xiaohongshu.com/",
    };
    const args: AxiosProxyParams = [
        { headers },
        _task.logger,
        params.proxyLoc,
        params.localIP,
        // params.huiwenToken,
        params.accountId,
    ];
    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: {} };

    const likesParams = {
        num: params.num ?? 20,
        cursor: params.cursor ?? "",
    };
    const fatchLikes = "/api/sns/web/v1/you/likes";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    const fatchLikesXsHeader = xsEncrypt.signHeadersGet(fatchLikes, recordCookie, "xhs-pc-web", likesParams);

    const res = await http.api<LikesResponse>(
        {
            method: "get",
            url: "https://edith.xiaohongshu.com/api/sns/web/v1/you/likes",
            params: likesParams,
            headers: fatchLikesXsHeader,
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = res.code === 0;
    const message = `获取点赞收藏${isSuccess ? "成功" : `失败，原因：${res.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? res.data : {};

    return response(isSuccess ? 0 : 414, message, data);
};
